/**
 * 报警计划一览
 * 创建时间：2017-02-22
 * 创建人：zhanlz
 * 修改人：baixx
 */
<template>
	<div class="wrapper-content animated fadeInRight tabBox" id="alarmplan-list">
		<div class="ibox-content" v-loading="loadingstatus" element-loading-text="加载中">
			<div class="form-horizontal">
				<div class="form-group">
					<label class="col-sm-1 control-label">报警名称</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.planName">
					</div>
					<label class="col-sm-1 control-label">报警种类</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.almType">
					       <option v-for="(almType, index) in almTypeList" v-bind:key="'almType' + index" :value="almType.udccode">{{almType.udcname}}</option>
				       </select>
					</div>
					<label class="col-sm-1 control-label">报警状态</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.isEnable">
					       <option v-for="(almEnable, index) in almEnableList" v-bind:key="'almEnable' + index" :value="almEnable.udccode">{{almEnable.udcname}}</option>
				        </select>
					</div>
					<label class="col-sm-1 control-label">报警级别</label>
					<div class="col-sm-2">
						<select class="form-control" v-model="queryParam.almLevel">
					       <option v-for="(almLevel, index) in almLevelList" v-bind:key="'almLevel' + index" :value="almLevel.udccode">{{almLevel.udcname}}</option>
				        </select>
					</div>
				</div>
				<div class="form-group">
					<label class="col-sm-1 control-label">创建人</label>
					<div class="col-sm-2">
						<input type="text" class="form-control" v-model.trim="queryParam.createName">
					</div>
				</div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
				    	<button type="button" v-if="permission.indexOf('alarmPlanList_reset') == -1" @click="resetQueryParams" class="btn btn-primary">重置</button>
				    	<button type="button" v-if="permission.indexOf('alarmPlanList_select') == -1" @click="searchInfo" class="btn btn-primary">查询</button>
					</div>
				</div>
				<div class="hr-line-dashed"></div>
				<div class="form-group">
				    <div class="col-sm-12 text-right">
				    	<button type="button" v-if="permission.indexOf('alarmPlanList_center') == -1" class="btn btn-primary" @click="goAlarmPlanHome">报警计划中心</button>
					</div>
				</div>
			</div>
			<!--表格开始-->
			<div class="table-responsive">
				<table class="table table-striped table-bordered table-hover">
					<thead>
						<tr role="row">
							<th v-for="(thead, index) in theadList" v-bind:key="'thead' + index" >{{thead}}</th>
						</tr>
					</thead>
					<transition-group name="list-complete" tag="tbody">
						<tr v-for="(planInfo,index) in planList" v-bind:key="'planInfo' + index" class="list-complete-item">
							<td v-if="permission.indexOf('alarmPlanList_delete') == -1" class="text-center" @click="removeItem(index)">
								<a class="glyphicon glyphicon-trash"></a>
							</td>
							<td>AP{{planInfo.id}}</td>
							<td>{{planInfo.planName}}</td>
							<td>{{planInfo.almTypeStr}}</td>
							<td>{{planInfo.almLevelStr}}</td>
							<td>{{planInfo.isEnableStr}}</td>
							<td>{{planInfo.contactType}}</td>
							<td>{{planInfo.vehicleCount}}</td>
							<td>{{planInfo.almTimerange.length>20?planInfo.almTimerange.substr(0,20)+'...':planInfo.almTimerange}}</td>
							<td>{{planInfo.createName}}</td>
							<td class="text-center">
								<a @click="goAlarmPlanEdit(planInfo.id,planInfo.planName,planInfo.almTypeStr,planInfo.almType)">编辑</a>
								<a v-if="permission.indexOf('alarmPlanList_detail') == -1" @click="goAlarmPlanDetail(planInfo.almType,planInfo.almTypeStr,planInfo.planName,planInfo.id)">详情</a>
							</td>
						</tr>
					</transition-group>
				</table>
			</div>
			<!--表格结束-->
			<Pagination v-if="planList.length>0" :pageInfo="pageInfo" v-on:getData="getParam"></Pagination>
		</div>
		<!--弹出框子组件-->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModalMsg">
			{{messageStr}}
			<div slot="footer">
		        <button @click="closeModalMsg" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
		<!--   弹出框子组件2        -->
		<tab-modal ref="modal2" size="small" title="提示" :scroll='scrollTop'  v-on:cancel="closeModal('modal2')">
			确定删除 {{planList[listIndex]?planList[listIndex].planName:''}} 报警计划？
			<div slot="footer">
		            <button @click="closeModal('modal2')" class="btn btn-primary">取消</button>
		            <button @click="removePlanItem()" class="btn btn-primary">确定</button>
		    </div>
		</tab-modal>
	</div>
</template>

<script>
	import Pagination from 'components/common/Pagination.vue'
	import TabModal from 'components/common/TabModal'
	import { OPERATE_EXCEPTION } from 'static/message'
	import {DICTIONARY_MAP, PAGE_NO} from 'static/constant'
	import {getDictionaryFromArray, getModel} from 'util/util'
	import classlist from 'util/classlist'
	import {mapState} from 'vuex'

	export default {
	  name: 'PageAlarmPlanList',
	  components: {
	    Pagination,
	    TabModal
	  },
	  data () {
	    return {
	      permission: this.$store.state.permission.permission['alarmPlanList'] ? this.$store.state.permission.permission['alarmPlanList'] : [],
	      loadingstatus: false,
	      planList: [],
	      almTypeList: [],                                       // 报警种类
	      almEnableList: [],                                      // 报警状态
	      almLevelList: [],                                       // 报警级别
	      pageInfo: {},
	      listIndex: 0,				                            // 列表索引
	      queryParam: {
	        planOwnerType: 1,
	        almLevel: '',										// 报警等级
	        almType: '',							            // 报警类型
	        createName: '',                                     // 创建人
	        isEnable: '',		                                // 报警状态
	        planName: '',		                                // 报警计划名
	        customerId: this.$store.state.user.groupid,			// 组织机构ID
	        page_index: 1                                      // 当前第几页
	      },
	      theadList: ['', '计划ID', '报警计划名称', '报警计划种类', '报警级别', '报警状态', '外报警方式', '监控车辆总数', '报警监控时段', '创建人', ''],
	      messageStr: '',					                        // 弹出框内容
	      scrollTop: '0'
	    }
	  },
	  beforeMount () {
	    this.queryParam.almType = this.$store.state.alarm.almplantype
		// 初始化信息
	    this.getTableInfo()
	    this.getUdc()
	  },
	  computed: {
	    ...mapState({
	      almtype: state => state.alarm.almplantype
	    })
	  },
	  watch: {
	    almtype: function (val) {
	      this.queryParam.page_index = 1
	      this.queryParam.almType = val
	      this.getTableInfo()
	    }
	  },
	  methods: {
			// 查询方法
	    searchInfo () {
	      this.queryParam.page_index = 1
	      this.getTableInfo()
	    },
			// 初始化
	    getTableInfo: function () {
	      this.loadingstatus = true
	      this.$http.get(process.env.API_ROOT + '/alarm/alarm-plans', {params: this.queryParam})
					.then((response) => {
	  if (response.body.success) {
	    if (response.body.data) {
	      const res = response.body.data
	      this.planList = res.list
	      const {pageNum, pages, total, isFirstPage, isLastPage} = res
	      this.pageInfo = {
	        pageNum: pageNum,
	        pages: pages,
	        total: total,
	        isFirstPage: isFirstPage,
	        isLastPage: isLastPage
	      }
	    }
	  } else {
					       this.openModalMsg(response.body.message)
	  }
	  this.loadingstatus = false
	}, (response) => {
					   this.openModalMsg(response.body.message)
				   this.loadingstatus = false
	})
					.catch((response) => {
				        this.openModalMsg(OPERATE_EXCEPTION)
			        this.loadingstatus = false
	})
	    },
	    getUdc () {
	      let udcType = [
	        DICTIONARY_MAP.ALARM_TYPE,
	        DICTIONARY_MAP.ALM_LEVEL,
	        DICTIONARY_MAP.ALM_STATUS
	      ]
	      let param = udcType.join(',')
	      this.$http.get(process.env.API_ROOT + '/system/udcs', {params: {udcTypes: param}})
				.then(res => {
	  if (res.data.success) {
					 	this.almTypeList = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.ALARM_TYPE)
				 	this.almEnableList = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.ALM_STATUS)
	    this.almLevelList = getDictionaryFromArray(res.data.data, DICTIONARY_MAP.ALM_LEVEL)
	  } else {
	    this.$parent.openModal(res.data.message)
	  }
	}, res => {
	  this.$parent.openModal(res.data.message)
	}).catch(res => {
	  this.$parent.openModal(OPERATE_EXCEPTION)
	})
	    },
			// 重置信息
	    resetQueryParams: function () {
	      this.queryParam = {
	        planOwnerType: 1,
	        almLevel: '',										// 报警等级
	        almType: '',							            // 报警类型
	        createName: '',                                     // 创建人
	        isEnable: '',		                                // 报警状态
	        planName: '',		                                // 报警计划名
	        customerId: this.$store.state.user.groupid,         // 用户ID
				    page_index: 1                                      // 当前第几页
	      }
	    },
			// 从分页组件获取页码参数
	    getParam: function (param) {
	      this.queryParam.page_index = param
	      this.getTableInfo()
	    },
			// 删除选中信息
	    removeItem: function (index) {
	      this.listIndex = index
	      this.openModal('modal2')
	    },
	    removePlanItem () {
	      this.closeModal('modal2')
	      this.$http.delete(process.env.API_ROOT + '/alarm/alarm-plans/' + this.planList[this.listIndex].id + '/almType/' + this.planList[this.listIndex].almType, {params: {planId: this.planList[this.listIndex].id}})
				.then(res => {
	  if (res.data.success) {
	    this.getTableInfo()
	  } else {
	    this.openModalMsg(res.data.message)
	  }
	}, res => {
	  this.openModalMsg(res.data.message)
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	})
	    },
			// 消息弹出框相关
	    openModal (ref) {
            	this.$refs[ref].open()
            	classlist.toggleScroll('close', '#alarmplan-list', this)
        	},
        	closeModal (ref) {
        		this.$refs[ref].close()
        		classlist.toggleScroll('open', '#alarmplan-list', this)
        	},
        	closeModalMsg () {
        		this.closeModal('modalMsg')
        	},
        	openModalMsg (message) {
        		this.messageStr = message
        		this.openModal('modalMsg')
        	},
        	goAlarmPlanHome () {
        		const obj = {
	          name: '报警计划中心',
	          id: 'PageAlarmPlanHome',
	          route: '/indexhome/alarmPlanHome',
	          No: 'alarmPlanHome'
	        }
	          this.$router.push({path: '/indexhome/alarmPlanHome'})
	          this.$store.dispatch('addTab', obj)
        	},
        	goAlarmPlanDetail: function (almType, almTypeStr, planName, planId) {
    		    let id = getModel(PAGE_NO[almType].pageNo)
    		    let routeid = PAGE_NO[almType].pageNo
	          const obj = {
	            name: almTypeStr + '-' + planName,
	            id: 'Page' + id,
	            route: '/indexhome/' + routeid + planId,
	            No: routeid + planId,
	            params: {mode: '1', planid: planId}
	          }
	          this.$router.push({path: '/indexhome/' + routeid + planId, query: {mode: '2', planid: planId}})
	          this.$store.dispatch('addTab', obj)
	        },
	    goAlarmPlanEdit: function (planid, name, type, typeid) {
	      let id = getModel(PAGE_NO[typeid].pageNo)
    		    let routeid = PAGE_NO[typeid].pageNo
	      let param = {
    				planId: planid,
    				type: '1'
    			}
	      let modename = 'edit'
	      const selfUrl = process.env.API_ROOT
	      this.loadingstatus = true
	      this.$http.get(selfUrl + '/alarm/alarm-plans/' + planid + '/info', {params: param})
					.then(res => {
	  if (res.body.success) {
	    const obj = {
	      name: type + '报警计划-' + name,
	      id: 'Page' + id,
	      route: '/indexhome/' + routeid + planid + modename,
	      No: routeid + planid + modename,
	      params: {mode: '1', planid: planid}
	    }
	    this.$router.push({path: '/indexhome/' + routeid, query: {mode: '1', planid: planid}})
	    this.$store.dispatch('addTab', obj)
	  } else {
	    this.openModalMsg(res.body.message)
	  }
	  this.loadingstatus = false
	}, res => {
	  this.openModalMsg(res.body.message)
	  this.loadingstatus = false
	}).catch(res => {
	  this.openModalMsg(OPERATE_EXCEPTION)
	  this.loadingstatus = false
	})
	    }
	  }
	}

</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// PageAlarmPlanList.vue?177034fa